import React, { Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ExplainerVideo from "./components/ExplainerVideo";
import ProblemSection from "./components/ProblemSection";
import SolutionSection from "./components/SolutionSection";
import FeaturesSection from "./components/FeaturesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import DemoSection from "./components/DemoSection";
import VisionSection from "./components/VisionSection";
import PricingPreview from "./components/PricingPreview";
import WaitlistSection from "./components/WaitlistSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

// Lazy load routes for better performance
const MemorianPage = lazy(() => import("./pages/MemorianPage"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const TermsOfService = lazy(() => import("./pages/TermsOfService"));
const AdminLogin = lazy(() => import("./pages/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard"));

// Loading fallback component
const LoadingFallback = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#5B4FE9]"></div>
  </div>
);

const HomePage = () => {
  return (
    <>
      <Navbar />
      <HeroSection />
      <ExplainerVideo />
      <ProblemSection />
      <SolutionSection />
      <FeaturesSection />
      <HowItWorksSection />
      <DemoSection />
      <VisionSection />
      <PricingPreview />
      <WaitlistSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </>
  );
};

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/become-memorian" element={<MemorianPage />} />
              <Route path="/become-gravoomer" element={<MemorianPage />} /> {/* Legacy redirect */}
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<TermsOfService />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/dashboard" element={<AdminDashboard />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
